import React, { memo } from 'react';
import type { AtlaskitAtlassianNavigationNav4Props } from '@atlassian/jira-atlassian-navigation-nav4/src/ui/atlaskit-atlassian-navigation-nav4/types.tsx';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/JSErrorBoundary.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import { PlaceholderNew } from '@atlassian/jira-placeholder/src/index.tsx';
import {
	PACKAGE_NAME,
	TEAM_NAME,
} from '@atlassian/jira-atlassian-navigation-nav4-common/src/common/constants.tsx';

const LazyAtlaskitAtlassianNavigationNav4 = lazyForPaint(() =>
	import(
		/* webpackChunkName: "async-jira-atlassian-navigation-nav4" */ './ui/atlaskit-atlassian-navigation-nav4/AtlaskitAtlassianNavigationNav4.tsx'
	).then(({ AtlaskitAtlassianNavigationNav4 }) => AtlaskitAtlassianNavigationNav4),
);

const AsyncAtlaskitAtlassianNavigationNav4 = memo((props: AtlaskitAtlassianNavigationNav4Props) => (
	<JSErrorBoundary
		id="asyncAtlaskitAtlassianNavigationNav4"
		packageName={PACKAGE_NAME}
		teamName={TEAM_NAME}
	>
		<PlaceholderNew name="lazyAtlaskitAtlassianNavigationNav4">
			<LazyAtlaskitAtlassianNavigationNav4 {...props} />
		</PlaceholderNew>
	</JSErrorBoundary>
));

AsyncAtlaskitAtlassianNavigationNav4.displayName = 'AsyncAtlaskitAtlassianNavigationNav4';

export default AsyncAtlaskitAtlassianNavigationNav4;
